import Model from "./abstract/Model";
import Vehicle from "./Vehicle";
import Address from "./Address";
import OpeningHoursSlot, { DAYS } from "./OpeningHoursSlot";

export default class Depot extends Model {
  constructor(props) {
    super();

    this.initializeAttributes(props, {
      address: Address,
      vehicles: value => Vehicle.list(value),
      opening_hours_slots: value => OpeningHoursSlot.list(value)
    });

    // if (props.id == 3) {
    //   console.log(props);
    // }

    if (this.opening_hours_slots) {
      this.opening_hours_per_day = [];
      DAYS.forEach(day => {
        const slots =
          this.opening_hours_slots.filter(
            item => item.days && item.days.indexOf(day) > -1
          ) || [];

        this.opening_hours_per_day.push({
          // ...slot,
          slots: slots,
          day: day
        });
      });
    }
  }

  initState(data = {}) {
    this.state = {
      available_vehicles: [],
      focused: false,
      selected: false,
      distance: null,
      ...data
    };
  }

  setVehicles(vehicles) {
    this.vehicles = vehicles;

    if (this.state?.available_vehicles) {
      this.state.available_vehicles = this.state.available_vehicles.filter(
        item => this.vehicles.find(vehicle => vehicle.id == item.id)
      );

      vehicles.forEach(vehicle => {
        const index = this.state.available_vehicles.findIndex(
          item => item.id == vehicle.id
        );

        if (index > -1) {
          this.state.available_vehicles[index] = vehicle;
        }
      });
    }
  }

  setAvailableVehicles(vehicles) {
    vehicles.forEach(vehicle => {
      const index = this.vehicles.findIndex(item => item.id == vehicle.id);

      if (index > -1) {
        this.vehicles[index] = vehicle;
      }
    });

    if (!this.state) this.initState();

    this.state.available_vehicles = vehicles;
  }

  select() {
    this.state.focused = true;
    this.state.selected = true;
  }

  deselect() {
    this.state.focused = false;
    this.state.selected = false;
  }

  get marker_color_key() {
    return this.marker_color?.key;
  }

  static isFiniteLatLng(lat, lng) {
    if (lat === "" || lng === "" || lat == null || lng == null) return false;

    return Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));
  }

  static hasCoordinates(model) {
    return Depot.isFiniteLatLng(
      model?.address?.latitude,
      model?.address?.longitude
    );
  }

  get has_coordinates() {
    return Depot.hasCoordinates(this);
  }
}
